export const TwentySeven = '7';